import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createPortableTextProjection } from '../projections/createPortableTextProjection'

export const createSectionAccordionProjection = (localeId: LocaleId) => {
  const PORTABLE_TEXT_PROJECTION = createPortableTextProjection(localeId)
  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
        spacing,
        topBorder,
        faqs[] {
          _key,
          ${coalesceLocaleField('question', localeId)},
          ${coalesceLocaleField(
            'answer',
            localeId,
          )}[]${PORTABLE_TEXT_PROJECTION},
        },
      }
  `
}
